import { render, staticRenderFns } from "./AllOrganizations.vue?vue&type=template&id=b5864ad8&scoped=true&"
import script from "./AllOrganizations.vue?vue&type=script&lang=js&"
export * from "./AllOrganizations.vue?vue&type=script&lang=js&"
import style0 from "./AllOrganizations.vue?vue&type=style&index=0&id=b5864ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5864ad8",
  null
  
)

export default component.exports